mutation IssueContractPaymentInvoice($id: ID!) {
  issueContractPaymentInvoice(id: $id) {
    id
    status
    expired
    invoiceUrl
    invoice {
      number
      issuedAt
      sentAt
      sentTo
      previousNumbers {
        number
        issuedAt
        reason
      }
    }
  }
}
